import { FC } from 'react';
import { useGetOrderPoint } from './hooks';
import { useAppSelector } from '@/app/store';
import { useTranslation } from 'react-i18next';
import { Suggester } from '@/shared/components';
import { InputedCityInfoType } from '@/widgets';

interface OrderPointSuggesterProps {
  className?: string;
  onSuccess: VoidFunction;
  inputClassName?: string;
  inputedCityInfo: InputedCityInfoType;
  setInputedCityInfo: ({ city, full, coordsCity, area }: InputedCityInfoType) => void;
}

export const OrderPointSuggester: FC<OrderPointSuggesterProps> = ({
  onSuccess,
  inputedCityInfo,
  setInputedCityInfo,
  ...props
}) => {
  const { t } = useTranslation('address');
  const { infoLoading } = useAppSelector((state) => state.order);

  const { inputedCity, setInputedCity, handleSuggestionOrderPointSelect, suggestions } = useGetOrderPoint({
    onSuccess,
    inputedCityInfo,
    setInputedCityInfo,
  });

  return (
    <Suggester
      {...props}
      loading={infoLoading}
      suggestions={suggestions}
      value={inputedCity}
      setValue={setInputedCity}
      placeholder={t('placeholders.city')}
      onSuggestionSelect={(suggestion) => {
        handleSuggestionOrderPointSelect(suggestion);
      }}
      onSuccess={onSuccess}
    />
  );
};
